// extracted by mini-css-extract-plugin
module.exports = {"cf-header":"styles_cf-header__1d2Ec","container":"styles_container__3doZ_","charts":"styles_charts__2eOfw","projectedSwitch":"styles_projectedSwitch__3fENU"};